var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTvActive = function SvgTvActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.5 20.167c0-.507.41-.917.917-.917h9.166a.917.917 0 1 1 0 1.833H6.417a.917.917 0 0 1-.917-.916ZM3.667 4.583a.917.917 0 0 0-.917.917v9.167c0 .506.41.916.917.916h14.666c.507 0 .917-.41.917-.916V5.5a.917.917 0 0 0-.917-.917H3.667ZM.917 5.5a2.75 2.75 0 0 1 2.75-2.75h14.666a2.75 2.75 0 0 1 2.75 2.75v9.167a2.75 2.75 0 0 1-2.75 2.75H3.667a2.75 2.75 0 0 1-2.75-2.75V5.5Zm3.666.917h12.834v7.333H4.583V6.417Z",
    clipRule: "evenodd"
  })));
};
export default SvgTvActive;